'use strict'
const addComponentEventListener = require('./addComponentEventListener')

module.exports = ({ datasetApi, getState, errorBoundaries }) => {
  const getRows = fetch =>
    async function(startRow, endRow /*, sorting, filter*/) {
      const { items, totalCount } = await fetch(startRow, endRow - startRow)
      return {
        pageRows: items,
        totalRowsCount: totalCount
      }
    }

  return {
    isValidContext() {
      return true
    },

    bindToComponent({ component: grid }, actions) {
      // Synchronously set initial data for SEO rendering
      actions.getInitialData().chain(({ items }) => {
        grid.rows = items
      })

      grid.dataFetcher = getRows(actions.fetch)

      addComponentEventListener(
        grid,
        'onCellSelect',
        ({ cellRowIndex }) => {
          datasetApi.setCurrentItemIndex(cellRowIndex)
        },
        errorBoundaries
      )

      addComponentEventListener(
        grid,
        'onRowSelect',
        ({ rowIndex }) => {
          datasetApi.setCurrentItemIndex(rowIndex)
        },
        errorBoundaries
      )
    },

    currentRecordModified({ component: grid }, actions, updatedFields) {
      grid.refresh()
    },

    recordSetLoaded({ component: grid }, actions) {
      grid.refresh()
    },

    currentViewChanged({ component: grid }, actions) {
      grid.refresh()
    },

    currentIndexChanged({ component: grid }, actions) {}
  }
}



// WEBPACK FOOTER //
// ./adapters/gridAdapter.js